import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';
import { Form, Dropdown, InputGroup } from 'react-bootstrap';
import countries from '../../assets/countryPrefix.json';
import { useFormikContext } from 'formik';

// 新增工具函数（放在组件外部）
const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, part) => acc?.[part], obj);
};

const setNestedValue = (obj, path, value) => {
  const parts = path.split('.');
  const last = parts.pop();
  let current = obj;

  for (const part of parts) {
    if (!current[part]) current[part] = {};
    current = current[part];
  }
  current[last] = value;
};

const PhoneInput = ({
  label = "Phone Number",
  required = true,
  prefixField = "basic.prefix",
  phoneField = "basic.phone",
  error,
  placeholder = "Enter phone number"
}) => {
  const { values, setFieldValue } = useFormikContext();
  const [searchTerm, setSearchTerm] = useState('');
  const prefix = String(getNestedValue(values, prefixField) ?? '');
  const selectedCountry = useMemo(() => {
    return countries.find(c => String(c.prefix) === prefix)
      || countries.find(c => c.code === 'US')
      || countries[0];
  }, [prefix]);

  // 过滤国家列表
  const filteredCountries = useMemo(() => {
    const lowerSearch = searchTerm.toLowerCase();
    return countries.filter(country =>
      country.name.toLowerCase().includes(lowerSearch) ||
      country.code.toLowerCase().includes(lowerSearch) ||
      country.prefix.includes(searchTerm)
    );
  }, [searchTerm]);

  // 使用 useCallback 优化事件处理函数
  const handleSelect = useCallback((country) => {
    setFieldValue(prefixField, country.prefix);
    setSearchTerm('');
  }, [prefixField]);

  // 优化表单变化处理
  const handlePhoneChange = useCallback((e) => {
    setFieldValue(phoneField, e.target.value);
  }, [phoneField]);

  return (
    <Form.Group className="mb-3">
      <Form.Label className="fw-5">
        {label} {required && <span className="text-danger">*</span>}
      </Form.Label>

      <InputGroup hasValidation>
        {/* 国家区号选择器 */}
        <Dropdown>
          <Dropdown.Toggle
            variant="outline-secondary"
          >
            {selectedCountry ? `${selectedCountry.prefix}` :
              getNestedValue(values, prefixField) || 'Select'}
          </Dropdown.Toggle>

          <Dropdown.Menu className="p-0">
            <div className="px-2 pt-2 pb-1 border-bottom">
              <Form.Control
                type="search"
                placeholder="Search country..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
              />
            </div>

            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {filteredCountries.map(country => (
                <Dropdown.Item
                  key={country.code}
                  onClick={() => handleSelect(country)}
                  className="d-flex align-items-center"
                >
                  <span className="flex-fill">{country.name}</span>
                  <span className="text-muted">{country.prefix}</span>
                </Dropdown.Item>
              ))}
            </div>
          </Dropdown.Menu>
        </Dropdown>

        {/* 电话号码输入 */}
        <Form.Control
          name={phoneField}
          value={getNestedValue(values, phoneField) || ''}
          onChange={handlePhoneChange}
          isInvalid={!!error}
          placeholder={placeholder}
          pattern="^[0-9]{6,15}$"
        />

        <Form.Control.Feedback type="invalid">
          {error}
        </Form.Control.Feedback>
      </InputGroup>
    </Form.Group>
  );
};

export default PhoneInput;